module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/电脑.42e5a44e.png";